// extracted by mini-css-extract-plugin
export default {"mainContainer":"editUserView_mainContainer__nePON","sidebarContainer":"editUserView_sidebarContainer__IcKyN","formContainer":"editUserView_formContainer__COegV"};